import { useState } from 'react';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import { formatDate } from '../../../utils/formatacoes';
import P from '../Paragraph';
import Span from '../Span';

const EventsTimeline = ({ eventos }) => {
  const [observacaoEvento, setObservacaoEvento] = useState(null);

  const getIcon = (situacao) => {
    switch (situacao) {
      case 1: //realizado
        return (
          <Span>
            <i
              className='icofont icofont-check-circled txt-success'
              style={{
                fontSize: '24px',
              }}
              title='Realizado'
            ></i>
          </Span>
        );
      case 2: //realizado com atraso
        return (
          <Span>
            <i
              className='icofont icofont-check-circled txt-danger'
              style={{
                fontSize: '24px',
              }}
              title='Realizado com Atraso'
            ></i>
          </Span>
        );
      case 4:
        return (
          <Span>
            <i
              className='icofont icofont-check-circled txt-purple'
              style={{
                fontSize: '24px',
              }}
              title='Pendente com atraso'
            ></i>
          </Span>
        );
      default: //pendente
        return (
          <Span>
            <i
              className='icofont icofont-check-circled txt-warning'
              style={{
                fontSize: '24px',
              }}
              title='Pendente'
            ></i>
          </Span>
        );
    }
  };

  const getObservacao = (observacao) => {
    observacao = observacao ?? '';
    let texto = observacao;
    let completo = null;

    if (texto.length > 50) {
      texto = observacao.substr(0, 50) + '...';
      completo = observacao;
    }

    const tag = <P title={observacao}>{texto}</P>;

    return { tag, completo };
  };

  const getBadge = (situacao, dataRealizada) => {
    let cor = '';
    let texto = '';

    switch (situacao) {
      case 1: //realizado
        cor = 'badge-success';
        texto = formatDate(dataRealizada);
        break;
      case 2: //realizado com atraso
        cor = 'badge-danger';
        texto = formatDate(dataRealizada);
        break;
      case 4: // pendente com atraso
        cor = 'badge-purple';
        texto = 'Pendente com atraso';
        break;
      default:
        cor = 'badge-warning';
        texto = 'Pendente';
        break;
    }

    return <span className={`badge ${cor}`}>{texto}</span>;
  };

  return (
    <div className='table-responsive'>
      <table
        className='table table-bordernone'
        style={{
          border: 0,
        }}
      >
        <tbody>
          {eventos &&
            eventos.map((evento, index) => {
              const observacao = getObservacao(evento.observacao);

              return (
                <tr key={index}>
                  <td
                    style={{
                      paddingLeft: 0,
                      paddingRight: 0,
                    }}
                  >
                    {getIcon(evento.situacao)}
                  </td>
                  <td
                    style={{
                      paddingLeft: 5,
                      paddingRight: 5,
                    }}
                  >
                    <h5>{evento.nome}</h5>
                    {observacao.tag}
                    {observacao.completo !== null && (
                      <Button className='p-0' color='link' onClick={() => setObservacaoEvento(observacao.completo)}>
                        Ver Mais
                      </Button>
                    )}
                  </td>
                  <td
                    className='text-end'
                    style={{
                      paddingLeft: 0,
                      paddingRight: 0,
                    }}
                  >
                    {getBadge(evento.situacao, evento.data_realizada)}
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>

      <Modal isOpen={observacaoEvento !== null} size='md'>
        <ModalBody>
          <P attrPara={{ style: { whiteSpace: 'pre-wrap' } }}>{observacaoEvento}</P>
        </ModalBody>

        <ModalFooter>
          <Button color='primary' onClick={() => setObservacaoEvento(null)}>
            Fechar
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default EventsTimeline;
